export default __webpack_public_path__ + "static/media/discord.3b6a061d.svg";